// Radio groups made of buttons behave like real ones: the group is one Tab stop (the chosen
// option), and the arrow keys move through it, choosing as they go.

/** The tabIndex for option `i`: only the chosen one (or the first, if none is) takes Tab. */
export function rovingTab(i: number, checked: boolean, anyChecked: boolean): 0 | -1 {
  return checked || (!anyChecked && i === 0) ? 0 : -1;
}

/** Arrow keys, Home and End on option `i` of `n`. */
export function onRadioKey(ev: KeyboardEvent, i: number, n: number, choose: (j: number) => void): void {
  const step = ev.key === "ArrowRight" || ev.key === "ArrowDown" ? 1 : ev.key === "ArrowLeft" || ev.key === "ArrowUp" ? -1 : 0;
  const j = step ? (i + step + n) % n : ev.key === "Home" ? 0 : ev.key === "End" ? n - 1 : -1;
  if (j < 0) return;
  ev.preventDefault();
  choose(j);
  const group = (ev.currentTarget as HTMLElement).closest('[role="radiogroup"]');
  group?.querySelectorAll<HTMLElement>('[role="radio"]')[j]?.focus();
}
